export default __webpack_public_path__ + "static/media/builder.d7687f15.png";